import React from "react";
import { Link } from "react-router-dom";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useI18n } from "@/contexts/LanguageContext";

export default function AuthLayout({ children, title, subtitle, testId }) {
  const { t } = useI18n();
  return (
    <div className="min-h-screen grid md:grid-cols-2" data-testid={testId}>
      {/* Manifesto side */}
      <div
        className="hidden md:flex flex-col justify-between p-12"
        style={{ backgroundColor: "hsl(var(--nvl-ink))", color: "hsl(var(--nvl-bg))" }}
      >
        <Link to="/" className="font-display text-2xl tracking-tight" data-testid="auth-brand-link">
          NO VAX LOVE
        </Link>
        <div>
          <p className="nvl-overline opacity-70">Manifesto</p>
          <p className="mt-4 font-display text-3xl leading-tight max-w-md">
            {t("landing.hero.title")}
          </p>
          <p className="mt-6 text-sm opacity-80 max-w-md">
            {t("common.slogan")}
          </p>
        </div>
        <p className="text-xs opacity-60">
          © {new Date().getFullYear()} NO VAX LOVE
        </p>
      </div>

      {/* Form side */}
      <div className="flex flex-col p-6 md:p-12">
        <div className="flex justify-between items-center">
          <Link to="/" className="md:hidden font-display text-lg tracking-tight">
            NO VAX LOVE
          </Link>
          <div className="ml-auto">
            <LanguageSwitcher compact />
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-center max-w-md w-full mx-auto py-10">
          <p className="nvl-overline" style={{ color: "hsl(var(--nvl-accent))" }}>
            NO VAX LOVE
          </p>
          <h1 className="mt-3 text-3xl md:text-4xl">{title}</h1>
          {subtitle ? (
            <p className="mt-3 text-sm" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
              {subtitle}
            </p>
          ) : null}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
